import { City, Company, Country } from 'src/app/components/shared/models/interface/parametrizacion.interface';
import { ClientPointCompany } from '../../../massive/models/clientPointCompany.interface';

export interface MuRoutingData {
  breadcrumb: string;
  country: Country;
  city: City;
  company: Company;
  cedi: ClientPointCompany;
  services?: string[];
}

export const MuRouteDeliveriesData = (data: MuRoutingData): MuRoutingData => {
  return data;
};
